import classnames from 'classnames';
import autobind from 'core-decorators/lib/autobind';

import { VODCSSModules } from 'shared/utils/wix-connect';

import Icon from 'widget/player-widget/components/icon/icon';

import styles from './closable-overlay.styl';


//Don't use this overlay anywhere except player. It subscribe to native events instead of react's on purpose.
@VODCSSModules(styles)
export default class ClosableOverlay extends React.Component {

  static propTypes = {
    closeOnBodyClick: React.PropTypes.bool,
    noPoster: React.PropTypes.bool,
    posterUrl: React.PropTypes.string,
    isFullWidth: React.PropTypes.bool,
    isInFullScreen: React.PropTypes.bool,
    onClose: React.PropTypes.func,
    children: React.PropTypes.any,
  };

  componentDidMount() {
    const { closeOnBodyClick } = this.props;

    if (closeOnBodyClick) {
      this.overlayNode.addEventListener('click', this.close);
    }

    this.overlayNode.addEventListener('click', this.stopPropagation);
  }

  componentWillUnmount() {
    const { closeOnBodyClick } = this.props;

    if (closeOnBodyClick) {
      this.overlayNode.removeEventListener('click', this.close);
    }

    this.overlayNode.removeEventListener('click', this.stopPropagation);
  }

  @autobind
  stopPropagation(event) {
    event.stopPropagation();
    event.preventDefault();
  }

  @autobind
  close(event) {
    this.stopPropagation(event);
    const { onClose } = this.props;

    onClose();
  }

  @autobind
  setOverlayNodeRef(node) {
    this.overlayNode = node;
  }

  get closeButton() {
    const { isInFullScreen } = this.props;

    const iconName = isInFullScreen ? 'thin-x' : 'exit';
    const styleName = classnames('close', {
      'close-fullscreen': isInFullScreen,
    });

    return (
      <Icon styleName={styleName}
            onClick={this.close}
            name={iconName} />
    );
  }

  render() {
    const { children, isFullWidth, isInFullScreen, posterUrl } = this.props;

    const styleNames = classnames('info-overlay', {
      'full-width': isFullWidth,
    });

    const contentStyleNames = classnames('content', {
      'full-screen': isInFullScreen,
      half: !isFullWidth && !posterUrl,
    });

    return (
      <div styleName={styleNames}
           ref={this.setOverlayNodeRef}>
        {this.closeButton}
        <div styleName={contentStyleNames}>
          {children}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/player-widget/components/new-player/components/closable-overlay/closable-overlay.js